import React from 'react';
import { Nav, Navbar, NavLink, NavDropdown } from 'react-bootstrap'

import logo from '../../static/logo.svg';

interface Props { role: String };
interface State { };

export default class Navigation extends React.Component<Props, State> {
    constructor(props : Props) {
        super(props);
    }

    /*componentDidUpdate(prevProps: Props, prevState: State) {
        console.log({prevProps, prevState});
    }*/

    render() {
        return (<div className="render-navigation">
            <Navbar expand="lg" variant="dark">
                <Navbar.Brand href="/" style={{paddingRight: '1rem'}}>
                    {/* <img className="navbar-logo" src={logo} /> */}
                    Prognosverktyg
                </Navbar.Brand>
                <Navbar.Toggle/>
                <Navbar.Collapse className="ml-auto">
                    <Nav className="mr-auto">
                        <NavDropdown title="Statistik" id="nav-stat-dd">
                            <NavDropdown.Item href="/stat/examen">
                                Prognos
                            </NavDropdown.Item>
                            <NavDropdown.Item href="/stat/fractional">
                                Fraktionsdiagram
                            </NavDropdown.Item>
                            <NavDropdown.Item href="/stat/agg/overview">
                                Översiktstabell
                            </NavDropdown.Item>
                            <NavDropdown.Item href="/stat/admission">
                                Statistik för Behörighet & Examen
                            </NavDropdown.Item>
                            <NavDropdown.Item href="/stat/courseresult">
                                Ämnes-/Kursstatistik
                            </NavDropdown.Item>
                            <NavDropdown.Item href="/stat/history">
                                Historik
                            </NavDropdown.Item>
                        </NavDropdown>
                        {/*<NavLink href="/admin" >
                            Administration
                        </NavLink>*/}
                    </Nav>
                    { 
                        this.props.role == 'ADMIN' ?
                            <Nav className="ml-auto">
                                <NavDropdown title="Administration" id="nav-stat-dd">
                                    <NavDropdown.Item href="/admin/permissions">
                                        Behörigheter
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="/admin/dataexport">
                                        Export av rådata
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        : null
                    }
                </Navbar.Collapse>
            </Navbar>
        </div>);
    }
}